import AddSkuPageDisclaimer from './AddSkuPageDisclaimer';

export default AddSkuPageDisclaimer;
